import { Pipe, PipeTransform } from '@angular/core';

/**
 * Formats a cents amount as USD using `Intl.NumberFormat`, e.g. 124500 -> "$1,245.00".
 * Lives inside the PFP module to keep the wire-shape (cents) explicit at call sites.
 * For shared widgets prefer the existing `currencyInPennies` pipe in SharedModule.
 */
@Pipe({ name: 'centsToDollars' })
export class CentsToDollarsPipe implements PipeTransform {
  private static readonly formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  public transform(cents: number | null | undefined): string {
    if (cents == null || isNaN(Number(cents))) {
      return '';
    }
    return CentsToDollarsPipe.formatter.format(Number(cents) / 100);
  }
}
